var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuyerShield = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-768.000000, -785.000000)",
  fill: "#241F20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(730.914683, 88.914683)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.085317, 643.085317)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.000000, 44.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.000000, 8.938891)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.447022645,6.01707954 L5.52098224,6.01645159 L5.51973687,14.0602901 C2.90535483,12.2619497 1.20164749,9.37043713 0.447022645,6.01707954 Z M13.1994021,6.01721032 C12.4469866,9.36014116 10.7516073,12.2440166 8.1512827,14.0434233 L8.15001402,6.01645159 Z M8.15094895,0.0635925225 C10.1069295,0.257536047 11.754243,0.892181421 13.5877865,1.92748925 C13.6242424,1.94805413 13.6469105,1.98731433 13.6466786,2.029262 C13.6431193,2.48608405 13.62416,2.93935665 13.5898782,3.38780403 L8.15001402,3.38741981 Z M5.51977115,0.0612229655 L5.52098224,3.38741981 L0.0567001394,3.38775094 C0.0224499297,2.93931966 0.00352526043,2.48606476 3.7451948e-06,2.029262 C-0.00033503773,1.98731433 0.0223330585,1.94805413 0.0587889658,1.92748925 C1.89967749,0.887925274 3.55303992,0.252324768 5.51977115,0.0612229655 Z"
})))))))));
export default SvgBuyerShield;